/**
 * @Author: Zewei
 * @Date:   2018-02-07T14:09:12+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-27T15:00:38+08:00
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchMonthlyReports, linkToNewRouter, exportMonthlyReports, emptyMonthlyReports } from '../../actions/employee-management-actions.js';
import { Table, Button, Spin, Select, Divider, Modal } from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import './style.less';

const { Option } = Select;
const { confirm } = Modal;

let currentYear = new Date().getFullYear(),
    currentMonth = new Date().getMonth() + 1,
    data = [];
for (let i = 0; i < 12; i++) {
  let stringifyMonth, date;
  currentMonth = currentMonth - 1;
  if (currentMonth === 0) {
      currentMonth = 12;
      currentYear = currentYear - 1;
  }
  stringifyMonth = `${currentMonth}`.length > 1 ? `${currentMonth}` : `0${currentMonth}`;
  date = `${currentYear}-${stringifyMonth}`;
  data.push({
    key: i,
    num: i + 1,
    date: date,
  });
}

const mapStateToProps = state => ({
    employeeManagement: state.employeeManagement,
    routing: state.routing
});
const mapDispatchToProps = { fetchMonthlyReports, linkToNewRouter, exportMonthlyReports, emptyMonthlyReports };

@connect(mapStateToProps, mapDispatchToProps)
class MonthyReportDetail extends Component {

        state = {
            formattedDate: null,
            param: null,
            pathname: null
        }

        columns = [{
            title: '部门',
            dataIndex: 'department_name',
            key: 'department_name',
          }, {
            title: '月初人数',
            dataIndex: 'EntryEarly',
            key: 'EntryEarly',
            render: (text, record) => (
                <span onClick={this.viewEmployeeDetail.bind(this, record, 1)} className="hoverLayout">
                    { text }
                </span>
            )
          }, {
            title: '月末人数',
            dataIndex: 'EntryEnd',
            key: 'EntryEnd',
            render: (text, record) => (
                <span onClick={this.viewEmployeeDetail.bind(this, record, 2)} className="hoverLayout">
                    { text }
                </span>
            )
          }, {
            title: '月底编制',
            dataIndex: 'authorizedStrength',
            key: 'authorizedStrength',
            render: (text, record) => (
                <span>
                    { text }
                </span>
            )
          }, {
            title: '本月入职',
            dataIndex: 'ThisMonthEntry',
            key: 'ThisMonthEntry',
            render: (text, record) => (
                <span onClick={this.viewEmployeeDetail.bind(this, record, 4)} className="hoverLayout">
                    { text }
                </span>
            )
          }, {
            title: '入职率',
            dataIndex: 'EntryRate',
            key: 'EntryRate',
            render: (text, record) => (
                <span>
                    { text }
                </span>
            )
          }, {
            title: '本月离职',
            dataIndex: 'LeaveCount',
            key: 'LeaveCount',
            render: (text, record) => (
                <span onClick={this.viewEmployeeDetail.bind(this, record, 6)} className="hoverLayout">
                    { text }
                </span>
            )
          }, {
            title: '离职率',
            dataIndex: 'LeaveRate',
            key: 'LeaveRate',
            render: (text, record) => (
                <span>
                    { text }
                </span>
            )
          }, {
            title: '本月调入',
            dataIndex: 'callIn',
            key: 'callIn',
            render: (text, record) => (
                <span onClick={this.viewEmployeeDetail.bind(this, record, 8)} className="hoverLayout">
                    { text }
                </span>
            )
          }, {
            title: '本月调离',
            dataIndex: 'callOut',
            key: 'callOut',
            render: (text, record) => (
                <span onClick={this.viewEmployeeDetail.bind(this, record, 9)} className="hoverLayout">
                    { text }
                </span>
            )
          }, {
            title: '待转正人数',
            dataIndex: 'TobePositive',
            key: 'TobePositive',
            render: (text, record) => (
                <span onClick={this.viewEmployeeDetail.bind(this, record, 10)} className="hoverLayout">
                    { text }
                </span>
            )
          }]

       componentDidMount() {
           this._getTableList()
       }

       _getTableList = () => {
           let { pathname } = this.props.routing.location, parameter, year, month, params;
           if (!pathname) return ;
           this.setState({
               pathname: pathname
           })
           parameter = pathname.match(/detail\/(.+)\/?/)[1];
           this.setState({formattedDate: parameter})
           year = parameter.slice(0, 4);
           month = parameter.slice(-2);
           params = {
               Year: year,
               Month: month
           }
           this.setState({
               dateParams: params
           })
           this._fetchTableList(params)
       }

       _fetchTableList = (params) => {
           this.props.fetchMonthlyReports(params)
       }

       handleDateChange = (date) => {
           this.props.emptyMonthlyReports()
           let url = `/employee/monthy-report-detail/${date}`;
           this.props.linkToNewRouter(url)
       }

       handleExportReports = () => {
           confirm({
             title: '确定导出?',
             okText: '确认',
             cancelText: '取消',
             onOk: () => {
               this.props.exportMonthlyReports(this.state.dateParams)
             },
             onCancel: () => {}
           })
       }

       componentWillReceiveProps(nextProps) {
           const { fileLocation, monthlyReportsList } = nextProps.employeeManagement;
           !monthlyReportsList && this._getTableList();
           fileLocation && window.open(fileLocation);
       }

       viewEmployeeDetail = (record, type) => {
           let { dateParams } = this.state,
           urlParams = `DepartmentId=${record.department_id}&MonthlyReportType=${type}&Year=${dateParams.Year}&Month=${dateParams.Month}`;
           let url = `/employee/employees-review/${urlParams}`;
           this.props.linkToNewRouter(url)
       }

       render() {
           const { monthlyReportsList } = this.props.employeeManagement;
           // MonthlyEarly 1, MonthlyEnd 2, ThisMonthEntry 4, ThisMonthLeave 6, ThisMonthTransferred 8, ThisMonthTransferAway 9, TobePositive 10;

           const fixedLayout = {marginBottom: 10};
           const { formattedDate } = this.state;
           return (
               <div className="app-module-item">
                   <div style={fixedLayout}>
                       报表月份:
                       {
                           data && formattedDate ?
                           <Select defaultValue={formattedDate} style={{ width: 140, marginLeft: 6 }} onChange={this.handleDateChange}>
                               {
                                   data.map((item) => (
                                      <Option key={item.date} value={item.date}>{ item.date }</Option>
                                   ))
                               }
                           </Select>
                           :
                           <Spin />
                       }
                       <Divider type="vertical" />
                       {this.props.access.monthyReport.export_value && <Button type="primary" icon="cloud-download-o" onClick={this.handleExportReports}>导出</Button>}
                   </div>
                   {
                       monthlyReportsList ?
                           <Table
                               columns={this.columns}
                               dataSource={monthlyReportsList}
                               rowKey={record => record.department_name}
                               scroll={{ x: 1200}}
                               // pagination={paginationCfg}
                           />
                           :
                           <Spin className="spin-center" />
                   }
               </div>
           )
       }
   }

  MonthyReportDetail = LayoutWrapper(MonthyReportDetail)

  export default MonthyReportDetail;



// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/MonthyReportDetail.js